import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import i18n from '../lang/i18n';
import {
  mdiAccount, mdiCctv, mdiCheck, mdiClockOutline, mdiClose, mdiDrag,
  mdiEmail, mdiHarddisk, mdiHistory, mdiHomeVariant, mdiLock,
  mdiLoginVariant, mdiLogoutVariant, mdiMemory, mdiPencil, mdiPlay,
  mdiRecordRec, mdiRefresh, mdiServer, mdiShieldHome, mdiSpeedometer,
  mdiTarget, mdiVideoBox, mdiVideoOffOutline,
} from '@mdi/js';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
    values: {
      account: mdiAccount,
      cctv: mdiCctv,
      check: mdiCheck,
      clockOutline: mdiClockOutline,
      close: mdiClose,
      drag: mdiDrag,
      email: mdiEmail,
      harddisk: mdiHarddisk,
      history: mdiHistory,
      homeVariant: mdiHomeVariant,
      lock: mdiLock,
      loginVariant: mdiLoginVariant,
      logoutVariant: mdiLogoutVariant,
      memory: mdiMemory,
      pencil: mdiPencil,
      play: mdiPlay,
      recordRec: mdiRecordRec,
      refresh: mdiRefresh,
      server: mdiServer,
      shieldHome: mdiShieldHome,
      speedometer: mdiSpeedometer,
      target: mdiTarget,
      videoBox: mdiVideoBox,
      videoOffOutline: mdiVideoOffOutline,
    },
  },
  theme: {
    themes: {
      light: {
        primary: '#0f9f8f',
        secondary: '#f59e0b',
        accent: '#14b8a6',
        error: '#e5484d',
        background: '#f4f7f9'
      },
    },
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});
